export default __webpack_public_path__ + "static/images/b595321980cd699362c1bb1e02e546cd.svg";